import Base from './Base';

export default class ContactDuplicate extends Base {
    get countPage() {
        return this.count - 1;
    }

    get labelCountMore() {
        const count = this.countPage > 0 ? this.countPage : 0;
        const s = count > 1 ? 's' : '';

        return `${count} duplicate${s}`;
    }
}
